export const SESSION_PACIENTE_KEY = "ppUL";
export const SESSION_EMAIL_OBLIGATORIO_KEY = "ppDebeActualizarEmail";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const tieneCorreoValido = (email) => {
  return EMAIL_REGEX.test(String(email || "").trim());
};

export const requiereActualizarCorreo = (paciente) => {
  return !tieneCorreoValido(paciente?.email);
};

